module.exports = __webpack_public_path__ + "static/media/Finansii-Web-al.dcc0ca6e.jpg";